const CheckIcon = (
  <svg
    className="fill-current"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m16.298 8.288 1.404 1.425-5.793 5.707c-.387.387-.896.58-1.407.58s-1.025-.195-1.416-.585l-2.782-2.696 1.393-1.437 2.793 2.707 5.809-5.701Z"
      fill="currentColor"
    />
    <path
      d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0Zm0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10Z"
      fill="currentColor"
    />
  </svg>
);

export default CheckIcon;
